// extracted by mini-css-extract-plugin
module.exports = {"container":"Products_container__38RKi","Products_List":"Products_Products_List__1zdsM"};